<template>
  <div>
    <div class="animated fadeIn" v-if="tax_rights === true">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">Add Tax</div>
            </div>

            <b-collapse id="collapse1" visible>
              <b-card-body>
                <div class="row">
                  <div class="col-sm-12">
                    <div v-if="message.sucess!=''" class="alert alert-success" >
                      <center>{{message.sucess}}</center>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" >
                      <label for="name">Tax Name <span class="star">*</span></label>
                      <b-form-input ref="txttaxname" type="text" class="form-control" v-model="taxname" placeholder="Enter Tax Name" @blur.native="chkExist()" :class="{'is-invalid':error.errorname}"></b-form-input>
                      <small class="form-text text-muted" v-if="error.errorname" ><strong style="color:red;">{{error.errorname}}</strong></small>
                    </div>
                  </div>
                  <template v-if="companyTaxType === 'US'">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="name">Sales Tax In %  <span class="star">*</span></label>
                        <input type="text" class="form-control" v-model="taxigst" placeholder="Enter Sales Tax In %" >
                        <small class="form-text text-muted" v-if="error.errorigst" ><strong style="color: red;">{{error.errorigst}}</strong></small>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="name">SGST In %  <span class="star">*</span></label>
                        <input type="text" class="form-control"   v-model="taxsgst"  placeholder="Enter SGST In %" >
                        <small class="form-text text-muted" v-if="error.errorsgst" ><strong style="color: red;">{{error.errorsgst}}</strong></small>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group" >
                        <label for="name">CGST In %  <span class="star">*</span></label>
                        <input type="text" class="form-control" v-model="taxcgst" placeholder="Enter CGST In %" >
                        <small  class="form-text text-muted" v-if="error.errorcgst" ><strong style="color: red;">{{error.errorcgst}}</strong></small>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="form-group" >
                        <label for="name">IGST In %  <span class="star">*</span></label>
                        <input type="text" class="form-control"  v-model="taxigst" placeholder="Enter IGST In %" >
                        <small  class="form-text text-muted" v-if="error.errorigst" ><strong style="color: red;">{{error.errorigst}}</strong></small>
                      </div>
                    </div>
                  </template>
                </div>
              </b-card-body>
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-sm btn-primary"  @click.prevent="savehsnrate()"><i class="fa fa-dot-circle-o"></i> Save</button>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">{{ companyTaxType === 'US' ? 'US Code Rate List Table' : 'HSN Rate List Table' }}<p v-show="hide">{{ tax_view }}</p></div>
            </div>
            <div class="card-body">
              <vue-good-table
              :columns="columns"
              :rows="rows"
              mode="remote"
              ref="my-table"
              :pagination-options="{
                    enabled: true,
                    perPage: 5,
                                }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'action'">
                    <span v-if="tax_rights === true">
                        <span v-if="props.row.company_id !== 'I2OCGLB'">
                          <i class="fa fa-edit" @click.prevent="edithsnrate(props.row)"></i>
                          <span v-if="props.row.isAssociated">
                            <i class="fa fa-trash" style="color: lightgrey; pointer-events: none;" v-b-tooltip.hover="'Cannot delete — this tax rate is linked to one or more products.'"></i>
                          </span>
                          <span v-else>
                            <i class="fa fa-trash" @click.prevent="deletehsnrate(props.row)"></i>
                          </span>
                        </span>
                        <span v-else>
                          <span v-if="is_admin === true">
                            <i class="fa fa-edit" @click.prevent="edithsnrate(props.row)"></i>
                            <span v-if="props.row.isAssociated">
                              <i class="fa fa-trash" style="color: lightgrey; pointer-events: none;" v-b-tooltip.hover="'Cannot delete — this tax rate is linked to one or more products.'"></i>
                            </span>
                            <span v-else>
                              <i class="fa fa-trash" @click.prevent="deletehsnrate(props.row)"></i>
                            </span>
                            </span>
                            <span v-else>
                               <i class="fa fa-edit" style="color:grey !important;"></i>
                               <i class="fa fa-trash" style="color:grey !important;"></i>
                            </span>

                        </span>
                      </span>
                      <span v-else>
                        <i class="fa fa-edit" style="color:grey !important;"></i>
                        <i class="fa fa-trash" style="color:grey !important;"></i>
                      </span>
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Edit Tax" no-close-on-esc no-close-on-backdrop  hide-footer size="lg" class="modal-info" v-model="warningModal" @ok="warningModal = false" ok-variant="warning">
      <div class="row">
        <div class="col-sm-12 alert alert-success" v-if="message.sucess!=''" style="text-align:center;">{{message.sucess}}</div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" >
            <label for="name">Tax Name : <span class="star">*</span></label>
            <input type="text" class="form-control" v-model="taxnameed" placeholder="Enter Tax Name">
            <small  class="form-text text-muted" v-if="error.errornameed" ><strong style="color: red;">{{error.errornameed}}</strong></small>
          </div>
        </div>
        <template v-if="companyTaxType === 'US'">
          <div class="col-sm-6">
            <div class="form-group" >
              <label for="name">Sales Tax : <span class="star">*</span></label>
              <input type="text" class="form-control" v-model="taxigsted" placeholder="Enter Sales Tax" >
              <small class="form-text text-muted" v-if="error.errorigsted" ><strong style="color: red;">{{error.errorigsted}}</strong></small>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-sm-2">
            <div class="form-group" >
              <label for="name">SGST : <span class="star">*</span></label>
              <input type="text" class="form-control" v-model="taxsgsted" placeholder="Enter SGST">
              <small class="form-text text-muted" v-if="error.errorsgsted" ><strong style="color: red;">{{error.errorsgsted}}</strong></small>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group" >
              <label for="name">CGST : <span class="star">*</span></label>
              <input type="text" class="form-control" v-model="taxcgsted" placeholder="Enter CGST">
              <small  class="form-text text-muted" v-if="error.errorcgsted" ><strong style="color: red;">{{error.errorcgsted}}</strong></small>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group" >
              <label for="name">IGST : <span class="star">*</span></label>
              <input type="text" class="form-control"  v-model="taxigsted" placeholder="Enter IGST" >
              <small  class="form-text text-muted" v-if="error.errorigsted" ><strong style="color: red;">{{error.errorigsted}}</strong></small>
            </div>
          </div>
        </template>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="submit" class="btn btn-sm btn-primary"  @click.prevent="savehsnrateed()"><i class="fa fa-dot-circle-o"></i> Save</button>
        </div>
      </div>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
 import Spinner from '../../spinner.vue'
export default {
  name: 'hsnrate',
  components: { Spinner },
  data(){
    return {
      // pg_view:false,
      // pg_rights:false,
      is_admin: false,
      shpfrst_time:false,
		  rfrst_time:false,
      hide:false,
      idtax:'',
      warningModal:false,
      loading:false,
      taxname:'',
      taxsgst:'',
      taxcgst:'',
      taxigst:'',
      taxnameed:'',
      taxsgsted:'',
      taxcgsted:'',
      taxigsted:'',
      totalRecords: 0,
      serverParams: {
      columnFilters: {
                   },
        sort: {
          // field: 'purchase_id',
          // type: 'asc',
              },
        page: 1,
        perPage: 5
      },
      rows:[],
        error:{
          errorname:false,
          errorsgst:false,
          errorcgst:false,
          errorigst:false,
          errornameed:false,
          errorsgsted:false,
          errorcgsted:false,
          errorigsted:false,

         },
         message:{
               sucess:'',

             }
    };
  },
  computed:{
      companyTaxType() {
        var companyId = localStorage.getItem('companyId') || ''
        return (this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId]) || 'IN'
      },
      columns() {
        if (this.companyTaxType === 'US') {
          return [
            { label: 'Tax Name', field: 'tax_name', width: '35% !important' },
            { label: 'Sales Tax', field: 'tax_igst', width: '20% !important' },
            { label: 'Action', field: 'action', width: '10% !important' },
          ]
        }
        return [
          { label: 'Tax Name', field: 'tax_name', width: '35% !important' },
          { label: 'SGST', field: 'tax_sgst', width: '15% !important' },
          { label: 'CGST', field: 'tax_cgst', width: '15% !important' },
          { label: 'IGST', field: 'tax_igst', width: '15% !important' },
          { label: 'Action', field: 'action', width: '10% !important' },
        ]
      },
      tax_view: function(){
        if(this.$store.getters.get_tax_view === true){
            this.shopuser('comp');
            this.getrate('comp');
            this.is_admin = this.$store.getters.get_is_admin
            return true
        }
        else{
          return false
        }
      },
      tax_rights: function(){
        return this.$store.getters.get_tax_rights
      }
  },
  // created(){
  //   var roles = JSON.parse(localStorage.getItem('roles'))
  //   // for (var i = 0; i < roles.length; i++) {
  //     if(roles[21].page_name == 22){

  //       this.pg_view = roles[21].view
  //       this.pg_rights = roles[21].rights
  //       this.pg_rights = false
  //       if(this.pg_view){
  //         this.shopuser();
  //         this.getrate();
  //       }
  //     }
    // }
  // },
   methods:{
    chkExist(){
        this.taxname = this.taxname.trim()
        if(this.taxname !== ''){
          var _this = this
          this.$http.get('/api/taxrates/chk_exist?filter[where][taxname]='+this.taxname).then(function (response){
            if(response.data.length > 0){
              _this.taxname = ''
              _this.error.errorname = 'Tax name already exist'
              _this.$refs["txttaxname"].focus()
            }
            else{
              _this.error.errorname = false
            }
          })
          .catch(function(error){
            _this.error.errorname = false
          });
        }
        else{
           this.error.errorname = false
        }
      },
    shopuser(val){
      if(val === 'comp'){
          if(this.shpfrst_time === false){
            this.shpfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){
      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },
    getrate(val){
      if(val === 'comp'){
          if(this.rfrst_time === false){
            this.rfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.loading = true
      this.$http.get('/api/taxrates?params='+JSON.stringify(filteParam))
      .then(function(response){
       _this.totalRecords = response.data[0].totalRecords;
        response.data.shift()
        if(response.data != undefined){
          _this.rows=response.data
          _this.loading = false
        }

      }).catch(function(error){
        _this.loading=false
      })
    },
   updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

      onPageChange(params) {
             this.updateParams({page: params.currentPage});
             this.getrate();
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage,page:1});
        this.getrate();
      },

      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },page:1
        });
        this.getrate();
      },

      onColumnFilter(params) {
        this.updateParams(params);
        this.getrate();
      },

     edithsnrate(val){
      this.warningModal=true;
      this.idtax=val.tax_id;
      this.taxnameed=val.tax_name;
      this.taxcgsted=val.tax_cgst;
      this.taxsgsted=val.tax_sgst;
      this.taxigsted=val.tax_igst;

     },
     deletehsnrate(val){
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        this.loading=true;
         var _this=this
         var id =val.id;
         this.$http.delete('/api/taxrates/'+id).then(function (response) {
          _this.loading=false;
          _this.getrate();
          })
          .catch(function (error) {
            _this.loading=false;
            console.log(error);
          });
        }
     },
      savehsnrate(){
          var _this=this;
          var submit=this.validation();
          if(submit==0){

          this.loading=true;
          this.error.errorname='';
          this.error.errorsgst='';
          this.error.errorcgst='';
          this.error.errorigst='';

          var data;
          if (this.companyTaxType === 'US') {
            // Auto-split Sales Tax (IGST) into SGST and CGST (50% each)
            var salesTax = parseFloat(this.taxigst) || 0;
            var splitTax = salesTax / 2;
            data = {
              tax_name: this.taxname,
              tax_cgst: splitTax,
              tax_sgst: splitTax,
              tax_igst: this.taxigst,
            }
          } else {
            data = {
              tax_name: this.taxname,
              tax_cgst: this.taxcgst,
              tax_sgst: this.taxsgst,
              tax_igst: this.taxigst,
            }
          }
          this.$http.post('/api/taxrates',data)
            .then(function(response){
                 _this.loading=false;
                 _this.message.sucess="Tax Added Successfully";
                 setTimeout(function(){ _this.message.sucess=false;}, 2000);
                  _this.getrate();
                 _this.reset();

            }).catch(function(error){
              console.log(error.response)
               _this.loading=false;
                 _this.message.sucess="SomeThing Went Wrong"

            })

          }



      },
      savehsnrateed(){

          var _this=this;
          var submit=this.validationed();
          if(submit==0){
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.loading=true;
          this.error.errorsgst=false;
          this.error.errorcgst=false;
          this.error.errorigst=false;
          _this.warningModal=false;

          var data;
          if (this.companyTaxType === 'US') {
            // Auto-split Sales Tax (IGST) into SGST and CGST (50% each)
            var salesTax = parseFloat(this.taxigsted) || 0;
            var splitTax = salesTax / 2;
            data = {
              tax_name: this.taxnameed,
              tax_cgst: splitTax,
              tax_sgst: splitTax,
              tax_igst: this.taxigsted,
            }
          } else {
            data = {
              tax_name: this.taxnameed,
              tax_cgst: this.taxcgsted,
              tax_sgst: this.taxsgsted,
              tax_igst: this.taxigsted,
            }
          }

          this.$http.post('/api/taxrates/update?where[id]='+this.idtax,data)

            .then(function(response){
                 _this.loading=false;
                 _this.message.sucess="Tax Updated Successfully";
                 setTimeout(function(){ _this.message.sucess=false;}, 2000);
                  _this.getrate();
                 _this.reset();
            }).catch(function(error){
              console.log(error.response)
               _this.loading=false;
                 _this.message.sucess="SomeThing Went Wrong"
            })
          }
      },

      validation(){
          var exp = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
          var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/
          var submit=0
          this.error.errorname =''
          this.error.errorcgst =''
          this.error.errorsgst =''
          this.error.errorigst =''


          if(this.taxname==''){
            this.error.errorname="Required "
            submit=1
          }
          else if(this.taxname.length > 20){
            this.error.errorname="Enter maximum 20 characters"
            submit=1
          }

          if (this.companyTaxType === 'US') {
            if(this.taxigst == ''){
              this.error.errorigst="Required"
              submit=1
            }
            else if(exp.test(this.taxigst)==false){
              this.error.errorigst="Enter Valid Tax"
              submit=1
            }
            else if(parseFloat(this.taxigst) > 50){
              this.error.errorigst="Maximum 50%"
              submit=1
            }
          } else {
            if(this.taxcgst == ''){
              this.error.errorcgst="Required"
              submit=1
            }
            else if(exp.test(this.taxcgst)==false){
              this.error.errorcgst="Enter Valid Tax"
              submit=1
            }
            else if(this.taxcgst > 50){
              submit=1
              this.error.errorcgst="Maximum 50%"
            }


            if(this.taxsgst == ''){
              this.error.errorsgst="Required"
              submit=1
            }
            else if(exp.test(this.taxsgst)==false){
              this.error.errorsgst="Enter Valid Tax"
              submit=1
            }
            else if(this.taxsgst > 50){
              submit=1
              this.error.errorsgst="Maximum 50%"
            }


            if(this.taxigst == ''){
              this.error.errorigst="Required"
              submit=1
            }
            else if(igstexp.test(this.taxigst)==false){
              this.error.errorigst="Enter Valid Tax"
              submit=1
            }
            if(this.taxigst > 100){
              this.error.errorigst="Maximum 100%"
              submit=1
            }
          }
          return submit;
      },

              validationed(){
                  var exp = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
                  var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/
                  var submit=0
                  this.error.errornameed =''
                  this.error.errorcgsted =''
                  this.error.errorsgsted =''
                  this.error.errorigsted =''


                  if(this.taxnameed=='')
                  {
                      this.error.errornameed="Required "
                       submit=1

                  }
                  if(this.taxnameed.length > 20)
                  {
                    this.error.errornameed="Maximum 20 characters"
                       submit=1
                  }

                  if (this.companyTaxType === 'US') {
                    if(this.taxigsted == '')
                    {
                       this.error.errorigsted="Required"
                       submit=1
                    }
                    else if(exp.test(this.taxigsted)==false){
                      if(parseFloat(this.taxigsted) > 50)
                      {
                       this.error.errorigsted="Maximum 50%"
                      }
                      else
                      {
                        this.error.errorigsted="Enter Valid Tax"
                      }
                      submit=1
                    }
                  } else {
                    if(exp.test(this.taxcgsted)==false){
                      if(this.taxcgsted > 50)
                      {
                       this.error.errorcgsted="Maximum 50%"
                      }
                      else
                      {
                        this.error.errorcgsted="Enter Valid Tax"
                      }

                      submit=1
                    }
                      if(this.taxcgsted == '')
                      {
                         this.error.errorcgsted="Required"
                         submit=1
                      }

                    if(exp.test(this.taxsgsted)==false){
                      if(this.taxsgsted > 50)
                      {
                       this.error.errorsgsted="Maximum 50%"
                      }
                      else
                      {
                        this.error.errorsgsted="Enter Valid Tax"
                      }

                      submit=1
                    }
                      if(this.taxsgsted == '')
                      {
                         this.error.errorsgsted="Required"
                         submit=1
                      }

                    if(igstexp.test(this.taxigsted)==false){
                      if(this.taxigsted > 100)
                      {
                       this.error.errorigsted="Maximum 100%"
                      }
                      else
                      {
                        this.error.errorigsted="Enter Valid Tax"
                      }

                      submit=1
                    }
                      if(this.taxigsted == '')
                      {
                         this.error.errorigsted="Required"
                         submit=1
                      }
                  }
                 return submit;

              },

              reset(){
                this.taxname=''
                this.taxsgst=''
                this.taxcgst=''
                this.taxigst=''
              }

    }
};
</script>


      <style type="text/css">
        .modal-header{
          background-color: #1a94cb;
          columns: #fff;
        }
      </style>



// WEBPACK FOOTER //
// src/views/setting/Hsnrate.vue